import _regeneratorRuntime from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _classCallCheck from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __awaiter } from "tslib";
import { Gain } from "../../core/context/Gain";
import { optionsFromArguments } from "../../core/util/Defaults";
import { readOnly } from "../../core/util/Interface";
import { Multiply } from "../../signal/Multiply";
import { Signal } from "../../signal/Signal";
import { Source } from "../Source";
import { Oscillator } from "./Oscillator";
import { generateWaveform } from "./OscillatorInterface";
/**
 * FMOscillator implements a frequency modulation synthesis
 * ```
 *                                              +-------------+
 * +---------------+        +-------------+     | Carrier Osc |
 * | Modulator Osc +>-------> GainNode    |     |             +--->Output
 * +---------------+        |             +>----> frequency   |
 *                       +--> gain        |     +-------------+
 *                       |  +-------------+
 * +-----------------+   |
 * | modulationIndex +>--+
 * +-----------------+
 * ```
 *
 * @example
 * return Tone.Offline(() => {
 * 	const fmOsc = new Tone.FMOscillator({
 * 		frequency: 200,
 * 		type: "square",
 * 		modulationType: "triangle",
 * 		harmonicity: 0.2,
 * 		modulationIndex: 3
 * 	}).toDestination().start();
 * }, 0.1, 1);
 * @category Source
 */

export var FMOscillator = /*#__PURE__*/function (_Source) {
  _inherits(FMOscillator, _Source);

  var _super = _createSuper(FMOscillator);

  function FMOscillator() {
    var _this;

    _classCallCheck(this, FMOscillator);

    _this = _super.call(this, optionsFromArguments(FMOscillator.getDefaults(), arguments, ["frequency", "type", "modulationType"]));
    _this.name = "FMOscillator";
    /**
     * the node where the modulation happens
     */

    _this._modulationNode = new Gain({
      context: _this.context,
      gain: 0
    });
    var options = optionsFromArguments(FMOscillator.getDefaults(), arguments, ["frequency", "type", "modulationType"]);
    _this._carrier = new Oscillator({
      context: _this.context,
      detune: options.detune,
      frequency: 0,
      onstop: function onstop() {
        return _this.onstop(_assertThisInitialized(_this));
      },
      phase: options.phase,
      type: options.type
    });
    _this.detune = _this._carrier.detune;
    _this.frequency = new Signal({
      context: _this.context,
      units: "frequency",
      value: options.frequency
    });
    _this._modulator = new Oscillator({
      context: _this.context,
      phase: options.phase,
      type: options.modulationType
    });
    _this.harmonicity = new Multiply({
      context: _this.context,
      units: "positive",
      value: options.harmonicity
    });
    _this.modulationIndex = new Multiply({
      context: _this.context,
      units: "positive",
      value: options.modulationIndex
    }); // connections

    _this.frequency.connect(_this._carrier.frequency);

    _this.frequency.chain(_this.harmonicity, _this._modulator.frequency);

    _this.frequency.chain(_this.modulationIndex, _this._modulationNode);

    _this._modulator.connect(_this._modulationNode.gain);

    _this._modulationNode.connect(_this._carrier.frequency);

    _this._carrier.connect(_this.output);

    _this.detune.connect(_this._modulator.detune);

    readOnly(_assertThisInitialized(_this), ["modulationIndex", "frequency", "detune", "harmonicity"]);
    return _this;
  }

  _createClass(FMOscillator, [{
    key: "_start",

    /**
     * start the oscillator
     */
    value: function _start(time) {
      this._modulator.start(time);

      this._carrier.start(time);
    }
    /**
     * stop the oscillator
     */

  }, {
    key: "_stop",
    value: function _stop(time) {
      this._modulator.stop(time);

      this._carrier.stop(time);
    }
  }, {
    key: "_restart",
    value: function _restart(time) {
      this._modulator.restart(time);

      this._carrier.restart(time);

      return this;
    }
  }, {
    key: "asArray",
    value: function asArray() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1024;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", generateWaveform(this, length));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Clean up.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(FMOscillator.prototype), "dispose", this).call(this);

      this.frequency.dispose();
      this.harmonicity.dispose();

      this._carrier.dispose();

      this._modulator.dispose();

      this._modulationNode.dispose();

      this.modulationIndex.dispose();
      return this;
    }
  }, {
    key: "type",
    get: function get() {
      return this._carrier.type;
    },
    set: function set(type) {
      this._carrier.type = type;
    }
  }, {
    key: "baseType",
    get: function get() {
      return this._carrier.baseType;
    },
    set: function set(baseType) {
      this._carrier.baseType = baseType;
    }
  }, {
    key: "partialCount",
    get: function get() {
      return this._carrier.partialCount;
    },
    set: function set(partialCount) {
      this._carrier.partialCount = partialCount;
    }
    /**
     * The type of the modulator oscillator
     */

  }, {
    key: "modulationType",
    get: function get() {
      return this._modulator.type;
    },
    set: function set(type) {
      this._modulator.type = type;
    }
  }, {
    key: "phase",
    get: function get() {
      return this._carrier.phase;
    },
    set: function set(phase) {
      this._carrier.phase = phase;
      this._modulator.phase = phase;
    }
  }, {
    key: "partials",
    get: function get() {
      return this._carrier.partials;
    },
    set: function set(partials) {
      this._carrier.partials = partials;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(Oscillator.getDefaults(), {
        harmonicity: 1,
        modulationIndex: 2,
        modulationType: "square"
      });
    }
  }]);

  return FMOscillator;
}(Source);